import { AlertTriangle, CheckCircle2, ClipboardCheck, XCircle } from "lucide-react";
import { Card } from "./ui";

export const PublishChecklistCard = ({ checklist, status }) => {
  if (!checklist) return null;
  const red = checklist.items.filter((i) => !i.ok && !i.warn).length;
  const pill = checklist.ready
    ? "bg-emerald-50 text-emerald-700 border-emerald-200"
    : "bg-red-50 text-red-700 border-red-200";
  return (
    <Card icon={ClipboardCheck} title="Pre-publish checklist" testid="publish-checklist-card"
          actions={<span data-testid="publish-checklist-pill" className={`px-2.5 py-0.5 rounded-full border text-xs font-medium ${pill}`}>
            {checklist.ready ? (status === "published" ? "Published · all green" : "Ready to publish") : `${red} blocking`}
          </span>}>
      <div className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5">
        {checklist.items.map((i) => (
          <div key={i.key} data-testid={`publish-check-${i.key}`} data-ok={i.ok ? "1" : "0"}
               className="flex items-start gap-2 py-1 border-b border-zinc-100 last:border-0">
            {i.ok ? <CheckCircle2 size={16} className="text-emerald-600 mt-0.5 shrink-0" />
                  : i.warn ? <AlertTriangle size={16} className="text-amber-600 mt-0.5 shrink-0" />
                  : <XCircle size={16} className="text-red-600 mt-0.5 shrink-0" />}
            <span className={`text-sm font-medium ${i.ok ? "text-zinc-800" : i.warn ? "text-amber-700" : "text-red-700"}`}>{i.label}{i.warn && !i.ok ? " (warning)" : ""}</span>
            <span className="text-xs text-zinc-500 mt-0.5 ml-auto text-right break-words max-w-[60%]">{i.detail}</span>
          </div>
        ))}
      </div>
      <p data-testid="publish-checklist-sentence"
         className={`mt-3 text-sm ${checklist.ready ? "text-emerald-700" : "text-red-700 font-medium"}`}>{checklist.sentence}</p>
    </Card>
  );
};
